import { render } from "./ExpertStatisticsCallerNumberReport.vue?vue&type=template&id=3b6b2630"
import script from "./ExpertStatisticsCallerNumberReport.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsCallerNumberReport.vue?vue&type=script&lang=js"

import "./ExpertStatisticsCallerNumberReport.vue?vue&type=style&index=0&id=3b6b2630&lang=css"
script.render = render

export default script